import React from 'react'

const SchoolRecordInput = ({ register, name, isRead, type = 'text', addClass='' }) => {
    return (
        <input
            type={type}
            {...register(name)}
            className={isRead ? `w-100 text-center border-0 bg-transparent ${addClass}` : `form-control form-control-sm ${addClass}`}
            disabled={isRead}
        />
    )
}

export default SchoolRecordInput